module.exports = __webpack_public_path__ + "media/images/application/gif/clock-85674c0a1e0971d7c146109d5d6e79f2.gif";